import axios, { AxiosResponse } from 'axios';
import type { NotificationResponse, BaseResponse } from '@/types/notification';
import { getApiUrl } from '@/config/config';

// 硬编码API URL，使用域名而不是IP
const API_URL = 'https://aivitahelper.xyz:8081/api/notifications';

// 确保请求携带token
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const notificationService = {
  // 获取所有系统通知
  getAllNotifications(page?: number, size?: number): Promise<AxiosResponse<NotificationResponse>> {
    const params: Record<string, number> = {};
    if (page !== undefined) params.page = page;
    if (size !== undefined) params.size = size;
    return axios.get(API_URL, { params });
  },

  // 获取未读系统通知
  getUnreadNotifications(page?: number, size?: number): Promise<AxiosResponse<NotificationResponse>> {
    const params: Record<string, number> = {};
    if (page !== undefined) params.page = page;
    if (size !== undefined) params.size = size;
    return axios.get(`${API_URL}/unread`, { params });
  },

  // 获取已读系统通知
  getReadNotifications(page?: number, size?: number): Promise<AxiosResponse<NotificationResponse>> {
    const params: Record<string, number> = {};
    if (page !== undefined) params.page = page;
    if (size !== undefined) params.size = size;
    return axios.get(`${API_URL}/read`, { params });
  },

  // 一键已读
  markAllAsRead(): Promise<AxiosResponse<BaseResponse>> {
    return axios.put(`${API_URL}/read-all`);
  },

  // 标记单条记录已读
  markAsRead(id: number): Promise<AxiosResponse<BaseResponse>> {
    return axios.put(`${API_URL}/${id}/read`);
  }
};